import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class Share extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    tips: cc.Node = null;
    @property(cc.Node)
    shareToWeChat: cc.Node = null;
    /**
     * updateDtoList: Array(12)
     0:
     id: 2
     name: "首次邀请"
     content: "奖励：邀请成功，可获得3元"
     applyMode: 3
     submitType: 1
     activityCycleType: 1
     status: 1
     myBountyMoney: 3
     friendBountyMoney: 0
     friendOnlineLength: 0
     activityDynamics: 1238
     activityDynamicsMoney: 45643
     activityHeat: 0
     activityDml: 1212
     __proto__: Object
     1: {id: 3, name: "首次好友投注", content: "好友投注100元，即可申请2元奖励", applyMode: 3, submitType: 2, …}
     2: {id: 4, name: "朋友圈点赞", content: "朋友圈点赞数量20个，即可申请2元奖励", applyMode: 3, submitType: 2, …}
     3: {id: 5, name: "微信群分享", content: "分享到1000人以上的微信群，即可获得10块", applyMode: 3, submitType: 2, …}
     4: {id: 6, name: "QQ群分享", content: "分享到1000人以上的QQ群，即可获得10块", applyMode: 3, submitType: 2, …}
     5: {id: 7, name: "每日微博分享", content: "每天分享一次，分享成功可领取1元", applyMode: 3, submitType: 2, …}
     6: {id: 8, name: "每日微信好友分享", content: "每天分享一次，分享成功可领取1元", applyMode: 3, submitType: 2, …}
     7: {id: 9, name: "每日朋友圈分享", content: "每天分享一次，分享成功可领取1元", applyMode: 3, submitType: 3, …}
     8: {id: 10, name: "每日空间分享", content: "每天分享一次，分享成功可领取1元", applyMode: 3, submitType: 3, …}
     9: {id: 11, name: "微信群1000人目标", content: "创建微信群，超过1000人，即可获得100元", applyMode: 3, submitType: 2, …}
     10: {id: 19, name: "122", content: "122", applyMode: 2, submitType: 0, …}
     11: {id: 20, name: "122a", content: "122a", applyMode: 2, submitType: 0, …}
     */
    start() {
        UIManager.showLoadingUI();
        NetworkLogic.agentshareTask(null, function (data) {
            UIManager.hideLoadingUI();
            console.log("======分享任务 data：", data);
            let list = data.updateDtoList;
            let children = this.content.children;
            //先隐藏多余item
            if (children.length > list.length) {
                for (let i = list.length; i < children.length; i++) {
                    children[i].active = false;
                }
            }
            for (let i = 0; i < list.length; i++) {
                let child = null;
                if (children.length > i) {
                    child = children[i];
                }
                else {
                    child = cc.instantiate(children[0]);
                }
                child.parent = this.content;
                children[i].getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
                children[i].getChildByName("labPaiMing").getComponent(cc.Label).string = list[i].name;
                children[i].getChildByName("labTotal").getComponent(cc.Label).string = list[i].activityDynamics;
                children[i].getChildByName("labMonthMoney").getComponent(cc.Label).string = list[i].activityDynamicsMoney;
                children[i].getChildByName("labShareReward").getComponent(cc.Label).string = list[i].content;
                let btnLabel = children[i].getChildByName("New Button").getChildByName("Label").getComponent(cc.Label);
                if (list[i].submitType === 0) {
                    if (list[i].applyMode === 1)
                        btnLabel.string = i18n.t('TuiGuangLayer.to_share');
                    else if (list[i].applyMode === 2)
                        btnLabel.string = i18n.t('Task.apply_reward');
                }
                else
                    btnLabel.string = i18n.t('Task.disclose_data');
                children[i].getChildByName("New Button").getComponent(cc.Button).clickEvents[0].customEventData = list[i].id + "," + list[i].applyMode + "," + list[i].submitType;
                child.active = true;
            }
        }.bind(this), function () {

        }.bind(this))
    }

    onBtnClick(event, param) {
        AudioManager.playSound("button");
        let sp = param.split(",");
        if (sp[2] === "0") {//submitType = 0 有两种 ： 1，分享 applyMode: 2 申请奖励；
            if (sp[1] === "1")
                this.shareToWeChat.active = true;
            else if (sp[1] === "2") {
                let data2 = {
                    taskId: sp[0],
                }
                UIManager.showLoadingUI();
                NetworkLogic.agentApplicationReward(data2, function (rec) {
                    UIManager.hideLoadingUI();
                    UIManager.showTipUI(i18n.t('Task.Succ_application_Award') + "！")
                }.bind(this), function () {
                    UIManager.hideLoadingUI();
                    cc.log("=====申请奖励错误")
                });
            }
        } else {
            this.tips.active = true;
            this.tips.emit("COMMITDATA", param);
        }
    }

}
